<template>
  <div class="document-status d-flex flex-column align-items-center justify-content-center" style="height: 370px; gap: 8px">
    <img width="32" heigth="32" src="@/assets/img/icons/tick-circle-success.svg" alt="">
    <h5>{{ $t('views.seller.my_account.text_1317') }}</h5>
    <div class="d-flex flex-column align-items-center">
      <p>{{ $t('views.seller.my_account.text_1318') }}</p>
      <p>{{ $t('views.seller.my_account.text_1319') }}</p>
    </div>
  </div>
</template>

<script>

export default {

};
</script>

<style scoped>
.document-status p, .document-status h5 {
  color: var(--Default-gray-900, #111827) !important;
}

.document-status h5 {
  font-size: 18px;
  font-weight: 600;
}
</style>
